import { takeLatest, all, call, put, select } from 'redux-saga/effects';

import {
  types,
  fetchSelectedQuestionSuccess,
  fetchSelectedQuestionFailed,
  getSelectedQuestionID,
  readSelectedQuestionSuccess,
  readSelectedQuestionFailed,
  fetchSelectedQuestion,
} from '../redux/selectQuestion';
import { fetchTutorStatistic } from '../redux/tutorStatic';
import { saveQuestionDetails } from '../redux/chatsMessage';
import { fetchAnswerStage } from '../redux/answerStage';
import { appendImages } from '../redux/images';
import { fetchChats } from '../redux/chatsMessage';
import { getTaggableSubtopics } from '../redux/tagging';
import { fetchQuestions } from '@coconut/services/redux/questionList';
import apis from '../apis/chat';
import * as mimeTypes from '@coconut/constants/mimeTypes';
import { hideChatAlertBanner } from '@coconut/scenes/Chat/services/redux/chatAlertBanner';

function* fetchSelectedQuestionFlow(action) {
  const { QID } = action.payload;

  try {
    const response = yield call(apis.getQuestion, QID);

    const {
      data: { question },
    } = response;

    const {
      picture_large_url, // eslint-disable-line camelcase
      picture_medium_url, // eslint-disable-line camelcase
      picture_thumb_url: pictureThumbUrl,
      picture_url, // eslint-disable-line camelcase
      audio_record_url: audioRecordUrl,
      asked_by: {
        snapask_uid, // eslint-disable-line camelcase
      } = {},
      description,
      created_at: createdAt,
      aasm_state: aasmState,
      answer_stage: answerStage,
    } = question;

    yield put(fetchSelectedQuestionSuccess(question));

    const questionDetails = [];
    const defaultMessageDetails = {
      question_id: parseInt(QID, 10),
      snapask_uid,
      aasmState,
      created_at: createdAt,
      answerStage,
    };
    // store question image in image reducer.
    // inexistence of picture_thumb_url implies client did not add image
    // when creating question.
    if (pictureThumbUrl) {
      const imageQuestion = {
        picture_large_url,
        picture_medium_url,
        picture_thumb_url: pictureThumbUrl,
        picture_url,
      };

      yield put(appendImages([imageQuestion]));

      questionDetails.push({
        mtype: mimeTypes.IMAGE,
        id: `${Date.now()}1`,
        ...imageQuestion,
        ...defaultMessageDetails,
      });
    }

    if (audioRecordUrl) {
      questionDetails.push({
        mtype: mimeTypes.AUDIO,
        id: `${Date.now()}2`,
        audio_record_url: audioRecordUrl,
        ...defaultMessageDetails,
      });
    }

    if (description) {
      questionDetails.push({
        mtype: mimeTypes.TEXT,
        id: `${Date.now()}3`,
        description,
        ...defaultMessageDetails,
      });
    }

    yield put(saveQuestionDetails(questionDetails));

    // check if "answered_by" equals to null.
    // if answered_by equals to null means
    // the question has not been picked up by tutor yet.
    // fetch tutor static info. if "answered_by"
    // exists.
    const { answered_by: answeredBy } = question;

    const { snapask_uid: tutorID } = answeredBy || {};

    if (tutorID) {
      yield put(fetchTutorStatistic(tutorID));
    }

    yield put(fetchAnswerStage(QID));
  } catch (err) {
    yield put(fetchSelectedQuestionFailed(err));
  }
}

function* readSelectedQuestionFlow() {
  const questionId = yield select(getSelectedQuestionID);

  try {
    yield call(apis.readQuestion, questionId);
    yield put(fetchQuestions());
    yield put(readSelectedQuestionSuccess());
  } catch (err) {
    yield put(readSelectedQuestionFailed(err));
  }
}

function* goToQuestionChatroomByIDFlow() {
  const QID = yield select(getSelectedQuestionID);
  yield put(hideChatAlertBanner());
  yield put(fetchSelectedQuestion(QID));
  yield put(fetchChats());
  yield put(getTaggableSubtopics());
}

export default function* () {
  yield all([
    takeLatest(types.FETCH_SELECTED_QUESTION, fetchSelectedQuestionFlow),
    takeLatest(types.READ_CURRENT_QUESTION, readSelectedQuestionFlow),
    takeLatest(
      types.GO_TO_QUESTION_CHATROOM_BY_ID,
      goToQuestionChatroomByIDFlow
    ),
  ]);
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/selectQuestion.js